/* eslint-disable max-len */
import { LandingPageCoverGetResponse } from '@1po/1po-bff-fe-spec/generated/backoffice/landing_page_cover/response/LandingPageCoverGetResponse';
import { LandingPageCoverSetActiveResponse } from '@1po/1po-bff-fe-spec/generated/backoffice/landing_page_cover/response/LandingPageCoverSetActiveResponse';
import {
  BACKOFFICE_LANDING_PAGE_COVER_GET_RESPONSE,
  BACKOFFICE_LANDING_PAGE_COVER_SET_ACTIVE_RESPONSE,
} from '@1po/1po-bff-fe-spec/generated/common/ResponseType';
import { all, call, put, takeEvery } from '@redux-saga/core/effects';
import { SagaIterator } from 'redux-saga';
import {
  sendGetLandingPageCoversRequest,
  sendSetLandingPageCoverActiveRequest,
  sendUploadLandingPageCoverRequest,
} from 'domains/landingPageCover/LandingPageCover.api';
import {
  setIsUploading,
  setLandingPageCoverActiveRequestSaga,
  setLandingPageCoverSetActiveResponse,
  setLandingPageCoversResponse,
  uploadLandingPageCoverRequestSaga,
} from 'domains/landingPageCover/LandingPageCover.store';
import {
  GET_LANDING_PAGE_COVERS_REQUEST,
  SET_LANDING_PAGE_COVER_ACTIVE_REQUEST,
  UPLOAD_LANDING_PAGE_COVER_REQUEST,
} from 'domains/landingPageCover/LandingPageCover.types';
import { WsResponse } from 'domains/webSockets/WebSocket.types';
import { notifyTop } from 'UI';
import { AppTranslation, sagaGuard } from 'utils';

export function* fetchLandingPageCoversRequestSaga(): SagaIterator {
  yield put(sendGetLandingPageCoversRequest());
}

export function* fetchLandingPageCoversResponseSaga(action: WsResponse<LandingPageCoverGetResponse>): SagaIterator {
  yield put(setLandingPageCoversResponse(action.payload));
}

export function* handleUploadLandingPageCoverRequestSaga(
  action: ReturnType<typeof uploadLandingPageCoverRequestSaga>,
): SagaIterator {
  yield put(setIsUploading(true));
  yield put(sendUploadLandingPageCoverRequest(action.payload));
}

export function* handleSetLandingPageCoverActiveRequestSaga(
  action: ReturnType<typeof setLandingPageCoverActiveRequestSaga>,
): SagaIterator {
  yield put(sendSetLandingPageCoverActiveRequest(action.payload));
}

export function* handleLandingPageCoverSetActiveResponseSaga(
  action: WsResponse<LandingPageCoverSetActiveResponse>,
): SagaIterator {
  yield put(setLandingPageCoverSetActiveResponse(action.payload));
  yield put(setIsUploading(false));
  yield call(
    notifyTop,
    'success',
    AppTranslation.t(
      'backoffice.landing_page_cover.success_message',
      'The landing page image has been changed successfully',
    ),
  );
  yield put(sendGetLandingPageCoversRequest());
}

export function* LandingPageCoverSagas(): SagaIterator {
  yield all([
    takeEvery(GET_LANDING_PAGE_COVERS_REQUEST, sagaGuard(fetchLandingPageCoversRequestSaga)),
    takeEvery(UPLOAD_LANDING_PAGE_COVER_REQUEST, sagaGuard(handleUploadLandingPageCoverRequestSaga)),
    takeEvery(SET_LANDING_PAGE_COVER_ACTIVE_REQUEST, sagaGuard(handleSetLandingPageCoverActiveRequestSaga)),
    takeEvery(BACKOFFICE_LANDING_PAGE_COVER_GET_RESPONSE, sagaGuard(fetchLandingPageCoversResponseSaga)),
    takeEvery(
      BACKOFFICE_LANDING_PAGE_COVER_SET_ACTIVE_RESPONSE,
      sagaGuard(handleLandingPageCoverSetActiveResponseSaga),
    ),
  ]);
}
